import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils.js';

type Props = {
  icon: LucideIcon;
  title: string;
  description?: string;
  /**
   * What to do about it. "There is nothing here" is a fact; "nobody has scanned
   * a drawing today — work appears here as it is scanned" is an answer, and it
   * is the difference between an empty screen and a broken one.
   */
  whatToDo?: string;
  action?: React.ReactNode;
  className?: string;
};

export function EmptyState({ icon: Icon, title, description, whatToDo, action, className }: Props): JSX.Element {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3 py-10 px-4 text-center', className)}>
      <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center">
        <Icon className="w-6 h-6 text-slate-400" />
      </div>
      <div>
        <p className="text-sm font-semibold text-slate-700">{title}</p>
        {description && <p className="text-xs text-slate-400 mt-1">{description}</p>}
        {whatToDo && (
          <p className="text-xs text-navy-600 mt-2 max-w-xs mx-auto bg-navy-50 border border-navy-100 rounded-lg px-3 py-1.5">
            {whatToDo}
          </p>
        )}
      </div>
      {action && <div>{action}</div>}
    </div>
  );
}
